<!-- TEMPLATE CONTRACT: Ui Button Component owns the visible Angular template structure for src/app/shared/ui/ui-button/ui-button.component.html. -->
<button
  class="ui-button"
  [class.ui-button--icon-only]="icon() && !ariaLabel()"
  [attr.data-variant]="variant()"
  [attr.data-size]="size()"
  [attr.aria-label]="translatedAriaLabel() || null"
  [disabled]="disabled()"
  [type]="type()"
  [class.ui-button--full]="fullWidth()"
>
  <!-- Conditional branch documents the visible UI state for this condition. -->
  @if (icon() && iconPosition() === 'start') {
    <span class="ui-button__icon material-symbols-rounded" aria-hidden="true">{{ icon() }}</span>
  }
  <span class="ui-button__label">
    <!-- Conditional branch documents the visible UI state for this condition. -->
    @if (label().trim()) {
      {{ translatedLabel() }}
    } @else if (translatedProjectedLabel()) {
      {{ translatedProjectedLabel() }}
    } @else {
      <ng-content />
    }
  </span>
  <!-- Conditional branch documents the visible UI state for this condition. -->
  @if (icon() && iconPosition() === 'end') {
    <span class="ui-button__icon material-symbols-rounded" aria-hidden="true">{{ icon() }}</span>
  }
  <!-- Conditional branch documents the visible UI state for this condition. -->
  @if (badgeText()) {
    <span class="ui-button__badge">{{ badgeText() }}</span>
  }
</button>
